import React, { useEffect, useMemo, useRef, useState } from 'react';
import ecommerce from '../img/ecommerce.png';
import logo from "../img/logo/Logo.png"
import { Link, useNavigate } from 'react-router-dom';
import { FaSignInAlt } from 'react-icons/fa'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import axios from '../apis/axios.js';
import LanguageSelector from "../utils/LanguageSelector.jsx"
import { useTranslation } from 'react-i18next';

const RESET_PASSWORD = "/users/reset-password";

const ResetPassword = () => {
    const newPassRef = useRef(null);
    const confirmNewPassRef = useRef(null);
    const { t, i18n } = useTranslation();
    const tResetPassword = t("resetPassword");
    const navigate = useNavigate()
    const from = "/login"

    const forgotPassData = JSON.parse(sessionStorage.getItem("forgot-password-data"))

    useEffect(() => {
        if (!forgotPassData) {
            navigate('/login', { replace: true })
        }
    }, [])

    const handleSendOtpCode = async (e) => {
        e.preventDefault();

        const new_password = newPassRef.current.value;
        const new_password_confirmation = confirmNewPassRef.current.value;

        try {
            const { data: response } = await axios.post(RESET_PASSWORD,
                JSON.stringify(
                    {
                        resetPassword: {
                            phone: forgotPassData?.phone,
                            new_password: new_password,
                            new_password_confirmation: new_password_confirmation
                        }
                    }
                ),
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } });

            toast.success(response?.message);

            localStorage.removeItem('forgot-password-data');

            setTimeout(() => {
                navigate(from, { replace: true })
            }, 2500)
        } catch (error) {
            toast.error(error?.response.data.message);
        }
    }

    return (
        <div className=''>
            <ToastContainer />
            <div className='flex'>
                {/* <div className={i18n.dir()==="rtl"?'flex':'flex body_bg'}> */}
                <div className='flex flex-col justify-center my-10 px-10 md:w-1/2 lg:w-1/2'>
                    <div className='flex justify-between mx-12'>
                        <div className=''>
                            <img src={logo} width={200} height={150} alt='logo' />
                        </div>
                        {/* <h2 className='uppercase'>
                            <sub className='m-2 bg-white font-extrabold p-2 rounded-xl'>
                                {tResetPassword.title} <span><FaSignInAlt style={{ display: 'inline' }} /></span>
                            </sub>
                        </h2> */}
                        <div className='w-32 md:hidden'>
                            <LanguageSelector />
                        </div>
                    </div>
                    <h3 className="text-lg font-normal md:text-lg mx-12 my-6 text-black/60">
                        {tResetPassword.subtitle}
                    </h3>
                    <form className="space-y-4 md:space-y-6 py-12 mx-12" onSubmit={handleSendOtpCode} method='post'>
                        <div>
                            <label htmlFor="new_password" className="mb-2 text-base">{tResetPassword.newPassLabel}</label>
                            <input ref={newPassRef} type='password' name="new_password" id="new_password" className="sm:text-xl bg-slate-100 rounded-lg w-full px-5 py-3" placeholder="" required />
                        </div>
                        <div>
                            <label htmlFor="new_password_confirmation" className="mb-2 text-base">{tResetPassword.confirmNewPassLabel}</label>
                            <input ref={confirmNewPassRef} type='password' name="new_password_confirmation" id="new_password_confirmation" className="sm:text-xl bg-slate-100 rounded-lg w-full px-5 py-3" placeholder="" required />
                        </div>
                        <button type="submit" className="font-extrabold uppercase w-full text-white bg-primary-color px-5 py-2.5 shadow-3">{tResetPassword.ResetBtnText}</button>
                    </form>
                </div>

                <div className='hidden md:block md:w-1/2 transparent_bg'>
                    <div className='login_svg_bg p-8 flex justify-end items-start min-h-screen'>
                        <img src={ecommerce} width={400} height={100} alt='login_svg_bg' className='self-end' />
                        <div className='w-32'>
                            <LanguageSelector />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword